import { useState, useRef, useContext } from 'react';

import { GlobalContext } from "../../../contexts/globalContext"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import CustomMultitouchComponent from '../../../files/CustomMultitouchComponent';

import DatePicker from 'react-datepicker';
import styled from 'styled-components';

import styles from './MultitouchCalendarComponent.module.css'

import 'react-datepicker/dist/react-datepicker.css';


const StyledDatePickerWrapper = styled.div`
  .react-datepicker {
    width: 100% !important;
    height: 755px !important;
    background-color: #221B3E !important;
    position: absolute;
    border-radius: 26px;
    border: none;
  }

  .react-datepicker__month-container {
    height: 100%;
    width: 100%;
    color: #33FFC8;
    font-size: 20px;
    border-radius: 26px;
  }

  .react-datepicker__header {
    background-color: #261E41  !important;
    border-bottom: none;
    border-radius: 26px;
  }

  .react-datepicker__week {
    display: flex;
    height: 90.5px;
    width: 655px;
    flex-direction: row;
    left: 51%;
    transform: translate(-50%, 0%);
    justify-content: space-evenly;
    align-items: center;
    position: relative;
  }

  .react-datepicker__current-month {
    height: 130px;
    color: #33FFC8;
    align-items: center;
    display: flex;
    font: normal normal 600 40px/50px "bio-sans";
    justify-content: space-around;
  }

  .react-datepicker__day-names {
    display: flex;
    left: 50%;
    transform: translate(-50%, 0%);
    flex-direction: row;
    width: 648px;
    justify-content: space-around;
    align-items: center;
    color: #eeeeee;
    font-size: 35px;
    position: relative;
  }

  .react-datepicker__day-name {
    color: #eeeeee;
    font: normal normal normal 40px/50px "bio-sans";
  }

  .react-datepicker__day {
    width: 70px;
    color: #eeeeee;
    font: normal normal 600 40px/50px "bio-sans";
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  
  .react-datepicker__day:hover {
    background-color: #33FFC880 !important;
  }

  .react-datepicker__day--weekend {
    color: #eeeeee !important;
  }

  .react-datepicker__day--selected {
    border: 1px solid  #33FFC8 !important;
    color: white;
    border-radius: 12px !important;
    background-color: transparent !important;
  }

    .react-datepicker__day--today {
    background-color: #33FFC8 !important;
    color: black !important;
    border-radius: 12px !important;
  }

  .react-datepicker__day--disabled {
    color: #ccc !important;
  }

  .react-datepicker__day--outside-month {
    color: #726FA8 !important;
  }

  .react-datepicker__day--before-today {
    opacity: 0.5;
    color: #4e5181 !important;
  }

  .react-datepicker__navigation--next {
    right: 80px !important;
    border-left-width: 10px;
    border-top-width: 10px;
    border-bottom-width: 10px;
  }

  .react-datepicker__navigation--previous {
    left: 80px;
    border-right-width: 10px;
    border-top-width: 10px;
    border-bottom-width: 10px;
  }

  .react-datepicker__navigation-icon::before {
    width: 21px;
    height: 21px;
  }

  .react-datepicker__navigation {
    width: 180px;
    height: 80px;
    top: 35px;
    right: 121px;
  }

  .react-datepicker__day:hover,
  .react-datepicker__day:focus,
  .react-datepicker__day--keyboard-selected {
    background-color: initial;
    color: white;
    outline: none;
    box-shadow: none;
  }
`;

const MultitouchCalendarComponent = ({ setOpenCalendar }) => {

    const { appWidth, appHeight } = useContext(GlobalContext);

    const mtRef = useRef(null);
    const isOpenCanvasRef = useRef(false);

    const [selectedDate, setSelectedDate] = useState(new Date());

    const options = {
        appWidth,
        appHeight,
        maxScale: 1.25,
        minScale: 0.5
    }

    const handleDateChange = (date) => setSelectedDate(date);

    const onMinScaleReached = () => {
        setOpenCalendar(false)
    }

    return (
        <CustomMultitouchComponent ref={mtRef}
            dragGesture={false}
            width="auto"
            height="auto"
            x={1000} y={150}
            onMinScaleReached={onMinScaleReached}
            options={options}
            dragGestureMouse={true} dragBox={{x: 0, y: 0, width: 794, height: 100}}
            isOpenCanvasRef={isOpenCanvasRef}
            >
            <div className={styles.component}>
                <div className={styles.line}></div>
                <div className={styles.upDiv}>
                    <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fal['calendar']} />
                    <label className={styles.calculatorLabel}>Calendar</label>
                    <FontAwesomeIcon className={styles.icon} onClick={() => { setOpenCalendar(false) }} icon={byPrefixAndName.fal['close']} />
                </div>
                <StyledDatePickerWrapper>
                    <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        inline
                        calendarStartDay={1}
                        dateFormat="MM/dd/yyyy"
                    />
                </StyledDatePickerWrapper>
            </div>
        </CustomMultitouchComponent>
    );
}

export default MultitouchCalendarComponent;
